module.exports = __webpack_public_path__ + "img/004.5f484295.png";